import axios from "axios";
import { useGetters } from "./getters";
import { useMutations } from "./mutations";

/**
 * Composable for managing customer loyalty information using Composition API
 * @returns {Object} Loyalty management methods
 */
export function useLoyalty() {
    const { canViewLoyalty, isLoggedIn, loggedinUserDetails } = useGetters();
    const { storeUserDetails } = useMutations();
    /**
     * Fetch customer loyalty information from API
     */
    const fetchCustomerLoyaltyInfo = async () => {
        if (!isLoggedIn.value) {
            return;
        }

        try {
            const response = await axios.get(
                process.env.VUE_APP_API_BASE + "auth/getCustomerLoyaltyInfo",
                {
                    headers: {
                        "Content-type": "application/json;multipart/form-data",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            );

            if (response.data.success && response.data.data.customer) {
                const customer = { ...loggedinUserDetails.value };
                const loyaltyData = response.data.data.customer;

                customer.pause_enroll_loyalty = loyaltyData.pause_enroll_loyalty;
                customer.can_enroll_loyalty = loyaltyData.can_enroll_loyalty;
                customer.is_enrolled_loyalty = loyaltyData.is_enrolled_loyalty;
                customer.loyalty_status = loyaltyData.loyalty_status;
                customer.notification_email = loyaltyData.notification_email;
                customer.available_points = loyaltyData.available_points;
                customer.expiring_points = loyaltyData.expiring_points;
                customer.dollars = loyaltyData.dollars;
                customer.pending_points = loyaltyData.pending_points;
                customer.lifetime_points = loyaltyData.lifetime_points;
                customer.claimed_rewards = loyaltyData.claimed_rewards;

                storeUserDetails(customer);

                if (canViewLoyalty.value) {
                    setTimeout(() => {
                        const elements = document.querySelectorAll('.petals-education');
                        if (elements.length > 0) {
                            elements.forEach((element) => {
                                element.classList.remove('d-none');
                            });
                        }
                    }, 1000);
                }
            }
        } catch (err) {
            console.log('An error occurred while retrieving the customer information. ', err);
        }
    };

    return {
        fetchCustomerLoyaltyInfo
    };
}

// Legacy mixin export for backward compatibility
export default {
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        loggedinUserDetails() {
            return this.$store.getters.loggedinUserDetails;
        },
        canViewLoyalty() {
            return this.$store.getters.canViewLoyalty;
        }
    },
    methods: {
        fetchCustomerLoyaltyInfo() {
            if (this.isLoggedIn) {
                axios
                    .get(process.env.VUE_APP_API_BASE + "auth/getCustomerLoyaltyInfo", {
                        headers: {
                            "Content-type": "application/json;multipart/form-data",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    }).then((response) => {
                        let customer = { ...this.loggedinUserDetails };
                        if (response.data.success && response.data.data.customer) {
                            customer.pause_enroll_loyalty = response.data.data.customer.pause_enroll_loyalty;
                            customer.can_enroll_loyalty = response.data.data.customer.can_enroll_loyalty;
                            customer.is_enrolled_loyalty = response.data.data.customer.is_enrolled_loyalty;
                            customer.loyalty_status = response.data.data.customer.loyalty_status;
                            customer.notification_email = response.data.data.customer.notification_email;
                            customer.available_points = response.data.data.customer.available_points;
                            customer.expiring_points = response.data.data.customer.expiring_points;
                            customer.dollars = response.data.data.customer.dollars;
                            customer.pending_points = response.data.data.customer.pending_points;
                            customer.lifetime_points = response.data.data.customer.lifetime_points;
                            customer.claimed_rewards = response.data.data.customer.claimed_rewards;
                            this.$store.commit('storeUserDetails', customer);
                            if (this.canViewLoyalty) {
                                setTimeout(() => {
                                    let elements = document.querySelectorAll('.petals-education');
                                    if (elements.length > 0) {
                                        elements.forEach((element) => {
                                            element.classList.remove('d-none');
                                        });
                                    }
                                }, 1000);
                            }
                        }
                    }).catch((err) => {
                        console.log('An error occurred while retrieving the customer information. ', err);
                    });
            }
        },
    }
};

